import type { ReactElement } from 'react';

import styled from 'styled-components';

export const StyledIndicator = styled.span(({ theme: { indents } }) => ({
  flexShrink: 0,
  position: 'relative',
  marginRight: indents.INDENT_1,
  marginLeft: indents.INDENT_1,
}));

export const StyledIcon = styled.svg(({ theme: { colors } }) => ({
  fill: colors.ICON_SECONDARY,
  position: 'absolute',
  top: 2,
}));

export type SortIndicatorProps = {
  /**
   * Дополнительный класс не активных иконок
   */
  iconInactiveClassName?: string;
  /**
   * Дополнительный класс иконки "вверх"
   */
  iconUpClassName?: string;
  /**
   * Дополнительный класс иконки "вниз"
   */
  iconDownClassName?: string;
  /**
   * Активна ли сортировка по выбранному параметру
   */
  isActive?: boolean;
  /**
   * По возрастанию ли сортировка
   */
  asc?: boolean;
};

export function SortIndicator({
  iconInactiveClassName = '',
  iconUpClassName = '',
  iconDownClassName = '',
  isActive = false,
  asc = true,
}: SortIndicatorProps): ReactElement {
  return (
    <StyledIndicator>
      {!isActive && (
        <StyledIcon
          width={16}
          height={16}
          viewBox="0 0 16 16"
          className={iconInactiveClassName}
        >
          <path d="M13.8 10.3L12 12.1V2H11V12.1L9.2 10.3L8.5 11L11.5 14L14.5 11L13.8 10.3Z" />
          <path d="M4.5 2L1.5 5L2.2 5.7L4 3.9V14H5V3.9L6.8 5.7L7.5 5L4.5 2Z" />
        </StyledIcon>
      )}

      {isActive && (
        <>
          {asc && (
            <StyledIcon
              width={16}
              height={16}
              viewBox="0 0 16 16"
              className={iconUpClassName}
            >
              <path d="M8 2L3 7L3.705 7.705L7.5 3.915V14H8.5V3.915L12.295 7.705L13 7L8 2Z" />
            </StyledIcon>
          )}

          {!asc && (
            <StyledIcon
              width={16}
              height={16}
              viewBox="0 0 16 16"
              className={iconDownClassName}
            >
              <path d="M12.295 8.295L8.5 12.085V2H7.5V12.085L3.705 8.295L3 9L8 14L13 9L12.295 8.295Z" />
            </StyledIcon>
          )}
        </>
      )}
    </StyledIndicator>
  );
}
